import { APP_TO_BUILD } from "../../../appsConfig";
import type { QuestionGuideRecord } from "@/types/questionGuides";

const GUIDE_BASE_URLS: Partial<Record<typeof APP_TO_BUILD, string>> = {
  electrical: "https://www.dakotaprep.com/ca/red-seal-exam-guides/",
  electrical_us: "https://www.dakotaprep.com/nec-exam-guides/",
};

const NEC_READ_TIMES: Readonly<Record<string, number>> = {
  "guide-to-appliance-load-calculation-questions-on-nec-electrical-exams": 7,
  "guide-to-general-lighting-load-questions-on-nec-electrical-exams": 9,
  "guide-to-load-calculations-for-heating-ac-questions-on-nec-electrical-exams": 7,
  "guide-to-range-demand-calculation-questions-on-nec-electrical-exams": 5,
  "guide-to-service-size-calculation-questions-on-nec-electrical-exams": 7,
  "guide-to-box-fill-sizing-questions-on-nec-electrical-exams": 8,
  "guide-to-conductor-sizing-insulation-termination-temperatures-on-nec-electrical-exams": 5,
  "guide-to-conduit-fill-calculation-questions-on-nec-electrical-exams": 8,
};

const GUIDE_SLUG_RE = /^[A-Za-z0-9_-]+$/;

export const questionGuidesBaseUrl = GUIDE_BASE_URLS[APP_TO_BUILD];

export function normalizeQuestionGuide(value: unknown): QuestionGuideRecord | null {
  if (!value || typeof value !== "object") return null;
  const candidate = value as Partial<QuestionGuideRecord>;
  if (
    typeof candidate.topic !== "string" ||
    typeof candidate.slug !== "string" ||
    typeof candidate.category !== "string"
  ) {
    return null;
  }

  const topic = candidate.topic.trim();
  const slug = candidate.slug.trim();
  const category = candidate.category.trim();
  if (!topic || !category || !GUIDE_SLUG_RE.test(slug)) return null;

  const readTimeMinutes =
    typeof candidate.readTimeMinutes === "number" &&
    Number.isFinite(candidate.readTimeMinutes) &&
    candidate.readTimeMinutes > 0
      ? Math.round(candidate.readTimeMinutes)
      : APP_TO_BUILD === "electrical_us"
        ? NEC_READ_TIMES[slug]
        : undefined;

  return { topic, slug, category, readTimeMinutes };
}
